import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { StepModalOption } from '../styled';

export const LeasedOptionWrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  gap: 20px;

  @media (min-width: ${({ theme }) =>
      `calc(${theme.tabletBreakpoint} + 1px)`}) {
    flex-direction: row;
  }
`;

export const LeasedOption = styled(StepModalOption)`
  width: 100%;
  height: 100%;
`;
